import imageCompression from "browser-image-compression"
import sanitizeHtml from "sanitize-html"
import parse from "html-react-parser"
import { startOfMonth, endOfMonth, format, add } from "date-fns"
import { utcToZonedTime } from "date-fns-tz"
import axios from "axios"
import html2canvas from "html2canvas"
import { UAParser } from "ua-parser-js"
import heic2any from "heic2any"
import _get from "lodash/get"

export const getQueryStringObject = () => {
  let serachStr = window.location.search.substr(1).split("&")
  if (serachStr === "") return {}
  let result = {}
  for (let i = 0; i < serachStr.length; ++i) {
    let p = serachStr[i].split("=", 2)
    if (p.length === 1) result[p[0]] = ""
    else result[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "))
  }
  return result
}

export const sortJsonByKey = (prevObj, order = "asc") => {
  if (order === "asc") {
    return Object.keys(prevObj)
      .sort()
      .reduce((obj, key) => {
        obj[key] = prevObj[key]
        return obj
      }, {})
  } else {
    return Object.keys(prevObj)
      .sort()
      .reverse()
      .reduce((obj, key) => {
        obj[key] = prevObj[key]
        return obj
      }, {})
  }
}

export const insertArrayItem = function (array, index, item) {
  let newArray = array.slice()
  newArray.splice(index, 0, ...item)
  return newArray
}

export const insertItem = function (array, index, item) {
  let newArray = array.slice()
  newArray.splice(index, 0, item)
  return newArray
}

export const removeItem = function (array, index) {
  let newArray = array.slice()
  newArray.splice(index, 1)
  return newArray
}

export const removeItemByVal = function (array, val) {
  return array.filter((e) => e !== val)
}
export const isEmpty = (obj) => {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false
  }
  return true
}

export const compressImage = async (file, options = {}) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      const imageFile = file

      let compressionOptions = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        // fileType: imageFile.type
      }
      if (options) {
        for (let key in options) {
          if (options.hasOwnProperty(key)) {
            let optionVal = options[key]
            compressionOptions[key] = optionVal
          }
        }
      }
      try {
        const compressedFile = await imageCompression(imageFile, compressionOptions)

        resolve(compressedFile) // write your own logic
      } catch (error) {
        reject(error)
      }
    })()
  })
}
export const convertHeicFile = (file, destType = "image/jpeg") => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      const sanitizedType = destType.toLowerCase()
      const destExtList = {
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/gif": "gif",
      }
      const targetExt = _get(destExtList, sanitizedType)
      if (file) {
        heic2any({ blob: file, toType: destType })
          .then((resultBlob) => {
            file = new File([resultBlob], file.name + `.${targetExt}`, {
              type: destType,
              lastModified: new Date().getTime(),
            })
            resolve(file)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      }
    })()
  })
}
export const zerofillFormat = (checkString) => {
  return checkString.toString().length === 1 ? "0" + checkString : checkString
}

export const getMonthesByPeriod = (startDate, endDate, options = {}) => {
  let resultMonthList = []
  if (endDate < startDate) {
    return resultMonthList
  } else {
    let sDate = startOfMonth(new Date(startDate))
    let eDate = endOfMonth(new Date(endDate))
    while (sDate <= eDate) {
      resultMonthList.push(format(sDate, "yyyy-MM"))
      sDate = add(sDate, { months: 1 })
    }
  }

  return resultMonthList
}

export const isValidDate = (dateString) => {
  let regEx = /^\d{4}-\d{2}-\d{2}$/
  if (!dateString.match(regEx)) return false
  let d = new Date(dateString)
  let dNum = d.getTime()
  if (!dNum && dNum !== 0) return false
  return d.toISOString().slice(0, 10) === dateString
}

export const formatPhoneNumber = (numberTxt = "") => {
  if (![10, 11].includes(numberTxt.length)) {
    return numberTxt
  }

  const frontNum = numberTxt.substr(0, 3)
  const middleNum = numberTxt.length === 10 ? numberTxt.substr(3, 3) : numberTxt.substr(3, 4)
  const endNum = numberTxt.length === 10 ? numberTxt.substr(6, 4) : numberTxt.substr(7, 4)
  return frontNum + "-" + middleNum + "-" + endNum
}

export const formatDate = (date, separator = "-") => {
  let d = date ? new Date(date) : new Date()
  let month = "" + (d.getMonth() + 1)
  let day = "" + d.getDate()
  let year = d.getFullYear()

  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return [year, month, day].join(separator)
}
export const getDateByTimezone = (timezone, date = new Date(), separator = "-") => {
  let zonedDate = utcToZonedTime(date, timezone)
  let formattedOutput = format(zonedDate, `yyyy${separator}MM${separator}dd`, {
    timeZone: timezone,
  })
  return formattedOutput
}
export const formatFeedDate = (date, spliter) => {
  const diction = {
    "01": "(월)",
    "02": "(화)",
    "03": "(수)",
    "04": "(목)",
    "05": "(금)",
    "06": "(토)",
    "00": "(일)",
  }
  date = new Date(date)
  const checkZero = (checkString) => {
    return checkString.toString().length === 1 ? "0" + checkString : checkString
  }

  const temp =
    `${checkZero(date.getFullYear().toString().slice(-2))}.${checkZero(
      date.getMonth() + 1
    )}.${checkZero(date.getDate())} ` +
    diction[`${checkZero(date.getDay())}`] +
    ` ${checkZero(date.getHours())}:${checkZero(date.getMinutes())} ${
      spliter ? ":" + checkZero(date.getSeconds()) : ""
    } `

  return temp
}

export const formatCommentDate = (date) => {
  const today = new Date()
  const timeValue = new Date(date)
  const betweenTimeS = Math.floor((today.getTime() - timeValue.getTime()) / 1000)
  const betweenTimeM = Math.floor((today.getTime() - timeValue.getTime()) / 1000 / 60)
  const betweenTimeHour = Math.floor(betweenTimeM / 60)
  const betweenTimeDay = Math.floor(betweenTimeM / 60 / 24)
  const betweenTimeMonth = Math.floor(betweenTimeDay / 30)

  if (betweenTimeS < 0) {
    return `0초`
  }
  if (betweenTimeS < 60) {
    return `${betweenTimeS}초`
  } else if (betweenTimeM < 60) {
    return `${betweenTimeM}분`
  } else if (betweenTimeHour < 24) {
    return `${betweenTimeHour}시간`
  }
  //주, 달
  else if (betweenTimeDay < 30) {
    return `${betweenTimeDay}일`
  } else if (betweenTimeDay > 30 && betweenTimeDay < 365) {
    return `${betweenTimeMonth}달`
  } else {
    return `${Math.floor(betweenTimeDay / 365)}년`
  }
}

export const calNextMonth = (date) => {
  const nextMonth = new Date(date)
  nextMonth.setDate(1)

  if (nextMonth.getMonth() === 11) {
    nextMonth.setFullYear(nextMonth.getFullYear() + 1)
    nextMonth.setMonth(0)
    nextMonth.setDate(1)
  } else {
    nextMonth.setMonth(nextMonth.getMonth() + 1)
  }

  return nextMonth
}

//able to set default style
//able to change link style
// able to change link text
//If domain is external domain, use target _blank
export const replaceTextURLToLink = (text) => {
  let urlRegex =
    /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gi

  if (text && text.length > 0) {
    let modifiedText = text.replace(urlRegex, (match) => {
      return `<a href="${match}" target="_blank" style="color: #0000ff">${match}</a>`
    })
    let sanitizedContent = sanitizeHtml(modifiedText, {
      allowedTags: ["a"],
      allowedAttributes: {
        a: ["href", "target", "style"],
      },
    })
    return parse(sanitizedContent)
  } else {
    return ""
  }
}

export const initArray = (length, value = null) => {
  let resultArr = []
  for (let i = 0; i < length; ++i) {
    resultArr.push(value)
  }
  return resultArr
}
export const convertDayArrToNumArr = (arr) => {
  let resultArr = initArray(7, false)
  let dayArr = arr
  if (Array.isArray(arr)) {
    for (let i = 0; i < dayArr.length; ++i) {
      if (typeof dayArr[i] === "string") {
        let currDay = dayArr[i].toLowerCase()
        switch (currDay) {
          case "sun":
            resultArr[0] = true
            break
          case "mon":
            resultArr[1] = true
            break
          case "tue":
            resultArr[2] = true
            break
          case "wed":
            resultArr[3] = true
            break
          case "thu":
            resultArr[4] = true
            break
          case "fri":
            resultArr[5] = true
            break
          case "sat":
            resultArr[6] = true
            break
          default:
            break
        }
      }
    }
    return resultArr
  } else {
    return false
  }
}
export const getDatesByDay = (
  startDate,
  endDate,
  dayArr = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]
) => {
  let resultDateList = []
  let dayNumArr = convertDayArrToNumArr(dayArr)

  if ([null, undefined].includes(startDate)) {
    startDate = new Date()
  }
  if ([null, undefined].includes(endDate)) {
    endDate = new Date()
  }

  let currDateObj = typeof startDate === "string" ? new Date(startDate) : startDate
  let endDateObj = typeof endDate === "string" ? new Date(endDate) : endDate
  while (currDateObj <= endDateObj) {
    let currDay = currDateObj.getDay()
    if (dayNumArr[currDay]) {
      resultDateList.push(formatDate(currDateObj))
    }
    currDateObj.setDate(currDateObj.getDate() + 1)
  }
  return resultDateList
}

export const convertViewPortWidthToPixel = (vw) => {
  return Math.round(window.innerWidth / (100 / vw))
}

export const convertViewPortHeightToPixel = (vh) => {
  return Math.round(window.innerHeight / (100 / vh))
}

export const isValidEmail = (value) => {
  const emailRegExp =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i

  return emailRegExp.test(value)
}

export const isValidPassword = (value) => {
  //[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]
  // origin  /^(?=.*[a-z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/
  const passwordRegExp =
    /^(?=.*[a-z])(?=.*\d)(?=.*[`!@#$%^&*×÷€£¥•()_+\-=\[\]{};':"\\|,.<>\/?~])[A-Za-z\d`!@#$%^&*×÷€£¥•()_+\-=\[\]{};':"\\|,.<>\/?~]{8,}/

  return passwordRegExp.test(value)
}

export const isValidNickname = (value) => {
  const nicknameRegExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|]{2,10}$/

  return nicknameRegExp.test(value)
}

export const isValidName = (value) => {
  const nameRegExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|]{2,50}$/

  return nameRegExp.test(value)
}

export const downloadFile = (content, fileName, contentType) => {
  let a = document.createElement("a")
  let file = new Blob([content], { type: contentType })
  a.href = URL.createObjectURL(file)
  a.download = fileName
  a.click()
}

export const getBase64FromUrl = async (url) => {
  try {
    const res = await axios.get(url, { responseType: "blob" })
    const mimeType = getFileMimeType(url)

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        let result = reader.result
        if (result.search("application/octet-stream") >= 0) {
          result = result.replace("application/octet-stream", mimeType)
        }
        resolve(result)
      }
      reader.onerror = reject
      reader.readAsDataURL(res.data)
    })
  } catch (error) {
    console.log("error")
    console.log(error)
  }
}

export const getFileMimeType = (fileName) => {
  const arrData = fileName.split(".")
  const fileExtension = arrData[arrData.length - 1]

  let mimeType = null
  if (["jpg", "jpeg"].includes(fileExtension)) {
    mimeType = "image/jpeg"
  } else if (fileExtension === "png") {
    mimeType = "iamge/png"
  } else if (fileExtension === "gif") {
    mimeType = "image/gif"
  }

  return mimeType
}

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(blob)
    } catch (err) {
      reject(err)
    }
  })
}
export const htmlToCanvas = (domRef, options = {}) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const renderOptions = {
          letterRendering: 1,
          allowTaint: false,
          useCORS: true,
          ...options,
        }
        html2canvas(domRef, renderOptions)
          .then((canvas) => {
            resolve(canvas)
          })
          .catch((err) => {
            reject(err)
          })
      } catch (err) {
        reject(err)
      }
    })()
  })
}
export const base64ToBlob = async (base64) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        fetch(base64)
          .then((res) => res.blob())
          .then((blob) => resolve(blob))
      } catch (err) {
        reject(err)
      }
    })()
  })
}

export const canvasToBase64 = (canvas, compressOptions = null) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        if (compressOptions === null) {
          resolve(canvas.toDataURL("image/jpeg"))
        } else {
          canvas.toBlob(async (blob) => {
            const options = {
              maxSizeMB: 0.3,
              useWebWorker: true,
              ...compressOptions,
            }
            let compImg = await compressImage(blob, options)
            compImg = await blobToBase64(compImg)
            resolve(compImg)
          }, "image/jpeg")
        }
      } catch (err) {
        reject(err)
      }
    })()
  })
}

export const styleJsonToCssStmt = (json) => {
  let styleStmt = ""
  if (typeof json !== "object") {
    return styleStmt
  }
  let styleObj = Object.assign({}, json)
  let styleObjKeys = Object.keys(styleObj)
  for (let key of styleObjKeys) {
    styleStmt += `${key}:${styleObj[key]};`
  }

  return styleStmt
}

export const formatPriceByLocale = (local, price, options = {}) => {
  return new Intl.NumberFormat(local, options).format(price)
}

export const delay = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time))
}
export const copyTxt = (text) => {
  let tmpTextarea = document.createElement("textarea")
  tmpTextarea.value = text
  document.body.appendChild(tmpTextarea)
  tmpTextarea.select()
  tmpTextarea.setSelectionRange(0, text.length)
  document.execCommand("copy")
  document.body.removeChild(tmpTextarea)
  return true
}

export const redirectExternal = (link) => {
  let parserObj = new UAParser()
  const OSInfo = parserObj.getOS()
  if (OSInfo["name"] === "iOS") {
    window.location.href = link
  } else {
    window.open(link, "_blank", "noopener,noreferrer")
  }
}
